import { render, staticRenderFns } from "./Project2.vue?vue&type=template&id=741f543a"
import script from "./Project2.vue?vue&type=script&lang=js"
export * from "./Project2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports